export interface Login {
    email:string;
    password:string;
}

export const initialLoginValues:Login = {
    email:"",
    password:""
}